import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { SidebarProvider } from '@/contexts/SidebarContext';
import AppSidebar from '@/components/AppSidebar';
import DashboardFooter from '@/components/DashboardFooter';
import { useSidebarContext } from '@/contexts/SidebarContext';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
import { Globe, Repeat } from 'lucide-react';
import { TrustHubMapperV1 } from '@/components/trust-hub/v1/TrustHubMapperV1';
import { Button } from '@/components/ui/button';

const GrowGEOLayout: React.FC = () => {
  const { compact } = useSidebarContext();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleNavigate = (page: string) => {
    switch (page) {
      case 'dashboard':
      case 'deep-analysis':
      case 'recommended':
      case 'faq-serp':
        navigate('/dashboard');
        break;
      case 'eco':
        navigate('/eco');
        break;
      case 'fact-check':
        navigate('/fact-check');
        break;
      case 'reddit-hn':
        navigate('/reddit-hn');
        break;
      case 'startup-stash':
        navigate('/startup-stash');
        break;
      case 'grow-geo':
        break;
      default:
        console.log('Unknown navigation target:', page);
    }
  };

  return (
    <div className="flex min-h-screen w-full bg-gradient-to-br from-background via-background to-secondary/20">
      <AppSidebar activePage="grow-geo" onNavigate={handleNavigate} />
      <div className={cn("flex-1 min-w-0 transition-all duration-300", !isMobile && (compact ? "ml-16" : "ml-64"))}>
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
          
          {/* Header Section */}
          <div className="text-center space-y-6 py-8">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="p-4 rounded-full bg-primary/10 backdrop-blur-sm">
                <Globe className="h-10 w-10 text-primary" />
              </div>
            </div>
            <h1 className="text-5xl font-bold bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
              Grow GEO - Trust Hub Mapper
            </h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              Analyze which websites are featured in LLM responses. Discover domain authority patterns 
              across AI-powered search results from OpenAI, Claude, and more.
            </p>
            <div className="flex justify-center">
              <Button variant="outline" onClick={() => navigate('/repetition-study')}>
                <Repeat className="w-4 h-4 mr-2" /> Repetition Study (multi-run analysis)
              </Button>
            </div>
          </div>

          {/* Main Content */}
          <div className="w-full">
            <TrustHubMapperV1 />
          </div>
          
        </div>
        <DashboardFooter />
      </div>
    </div>
  );
};

const GrowGEO: React.FC = () => {
  return (
    <SidebarProvider>
      <GrowGEOLayout />
    </SidebarProvider>
  );
};

export default GrowGEO;
